const f = {
  DEFAULT: "#dc2626",
  50: "#fef2f2",
  100: "#fee2e2",
  200: "#fecaca",
  300: "#fca5a5",
  400: "#f87171",
  500: "#ef4444",
  600: "#dc2626",
  700: "#b91c1c",
  800: "#991b1b",
  900: "#7f1d1d",
  950: "#450a0a"
}, e = {
  DEFAULT: "#1dc396",
  50: "#f0fdf9",
  100: "#d6f7ed",
  200: "#adefdc",
  300: "#86f0d1",
  400: "#39ecbd",
  500: "#30d8a7",
  600: "#1dc396",
  700: "#178d6a",
  800: "#165f4a",
  900: "#0a2b21"
}, a = {
  DEFAULT: "#eab308",
  50: "#fefce8",
  100: "#fef9c3",
  200: "#fef08a",
  300: "#fde047",
  400: "#facc15",
  500: "#eab308",
  600: "#ca8a04",
  700: "#a16207",
  800: "#854d0e",
  900: "#713f12",
  950: "#422006"
}, c = {
  DEFAULT: "#6b7280",
  50: "#f9fafb",
  100: "#f3f4f6",
  200: "#e5e7eb",
  300: "#d1d5db",
  400: "#9ca3af",
  500: "#6b7280",
  600: "#4b5563",
  700: "#374151",
  800: "#1f2937",
  900: "#111827",
  950: "#030712"
}, d = {
  DEFAULT: "#3b82f6",
  50: "#eff6ff",
  100: "#dbeafe",
  200: "#bfdbfe",
  300: "#93c5fd",
  400: "#60a5fa",
  500: "#3b82f6",
  600: "#2563eb",
  700: "#1d4ed8",
  800: "#1e40af",
  900: "#1e3a8a",
  950: "#172554"
}, s = {
  green: e,
  red: f,
  yellow: a,
  gray: c,
  blue: d
}, o = {
  ...s,
  primary: e.DEFAULT,
  secondary: c.DEFAULT,
  warning: a.DEFAULT,
  danger: f.DEFAULT,
  error: f.DEFAULT,
  success: e.DEFAULT,
  info: d.DEFAULT
}, b = {
  sans: ["Poppins", "sans-serif"],
  mono: ["Viga", "sans-serif"]
};
export {
  s as colorPalettes,
  o as colors,
  b as fontFamily
};
